import { Component, Input } from '@angular/core';

/**
 * Loading bar of a box that loads data. Put it as the first child of the box (the box gets the
 * .app-loading-host class) and bind [loading]: the bar sits on the box's top edge, clipped to its rounded
 * corners, and never moves the content.
 */
@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false,
})
export class LoadingIndicatorComponent {
  /** Shows the bar. */
  @Input() loading = true;
  /** data-testId of the bar (present only while loading). */
  @Input() testId = 'loading-indicator';
}
